import { useGetIdentity, useLogout } from '@refinedev/core'
import { Avatar, Space } from 'antd'
import { useTranslation } from 'react-i18next'

import { isProxySession } from '../lib/auth-storage'
import { HeaderBar, HeaderLogoutButton, HeaderUserName } from './responsive'

interface DealerIdentity {
  userId: string
  nickname: string
  profileImage: string | null
}

export function DealerHeader() {
  const { t } = useTranslation()
  const { data: identity } = useGetIdentity<DealerIdentity>()
  const { mutate: logout } = useLogout()

  return (
    <HeaderBar title={t('layout.header.appTitle')}>
      {identity && (
        <Space size="small" align="center">
          <Avatar size={32} src={identity.profileImage}>
            {identity.nickname.charAt(0)}
          </Avatar>
          <HeaderUserName>{identity.nickname}</HeaderUserName>
        </Space>
      )}
      {/* 슈퍼관리자 대행 접속(#273)에서는 로그아웃이 곧 접속 종료다 */}
      <HeaderLogoutButton
        label={isProxySession() ? t('auth.proxy.end') : t('layout.header.logout')}
        onClick={() => logout()}
      />
    </HeaderBar>
  )
}
